import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme, isProPlan, bannerExpanded }) => {
    const bannerHeight = isProPlan ? '242px' : '276px';

    return css`
      align-items: ${bannerExpanded ? 'center' : 'flex-start'};
      background: ${isProPlan ? theme.v2.colors.gradient.secondary : theme.v2.colors.gradient.primary};
      border-radius: 16px;
      color: ${theme.v2.colors.neutral.highPure};
      display: flex;
      flex-direction: column;
      font-family: ${theme.v2.font.family.primary};
      gap: 24px;
      height: ${bannerExpanded ? bannerHeight : '80px'};

      padding: ${bannerExpanded ? '32px 0px 40px 0px' : '16px 24px'};
      position: relative;
      transition: height 0.3s ease-in-out;
      width: 100%;

      @media (max-width: ${theme.v2.breakpoints.sm}) {
        align-items: center;
        border-radius: 0;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 0px;
        height: fit-content;
        justify-content: space-between;
        overflow: visible;
        padding: 20px;
      }
    `;
  }}
`;

export const Header = styled.div`
  ${({ theme, bannerExpanded }) => css`
    align-items: center;
    display: ${bannerExpanded ? 'flex' : 'none'};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.bold};
    gap: 8px;
    line-height: 24px;
    position: relative;
    
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xs};
      gap: 4px;
      min-height: 40px;
    }

    @media (max-width: 380px) {
      max-width: 105px;
    }
  `}
`;

export const Title = styled.h2`
  ${({ theme, bannerExpanded }) => css`
    display: ${bannerExpanded ? 'block' : 'none'};
    font-size: ${theme.v2.font.sizes.sm};
    font-weight: ${theme.v2.font.weights.regular};
    line-height: 28.8px;
    margin: 0;
  `}
`;

export const Credits = styled.button`
  ${({ theme }) => css`
    align-items: center;
    background: rgba(255, 255, 255, 0.24);
    border-radius: 1000px;
    color: ${theme.v2.colors.neutral.highPure};
    display: flex;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xxs};
    font-weight: ${theme.v2.font.weights.bold};
    gap: 8px;
    height: 40px;
    justify-content: center;
    line-height: 16px;
    margin: 0;
    padding: 16px;
    transition: top 0.3s ease-in-out, right 0.3s ease-in-out;
    border: none;
    cursor: pointer;

    :hover {
      background: rgba(255, 255, 255, 0.32);
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      position: relative;
      right: 0;
      top: 0;
    }
  `}
`;

export const ButtonGroup = styled.div`
  ${({ theme, bannerExpanded }) => css`
    display: flex;
    gap: 16px;
    position: ${bannerExpanded ? 'relative' : 'absolute'};
    ${!bannerExpanded && css`
      top: 16px;
      left: 24px;
      opacity: 0;
      animation: appearFromBottom 0.3s ease-in-out 0.2s forwards;
    `}

    @keyframes appearFromBottom {
      from {
        transform: translateY(100%);
      }
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      animation: none;
      gap: 8px;
      justify-content: flex-start;
      left: 0;
      opacity: 1;
      overflow: auto;
      scrollbar-width: none;
      margin-top: 32px;
      position: relative;
      top: 0;
      width: 100%;
    }
  `}
`;

export const Button = styled.button`
  ${({ theme, active }) => css`
    align-items: center;
    backdrop-filter: blur(16px);
    background: ${active ? theme.v2.colors.neutral.highPure : 'rgba(255, 255, 255, 0.16)'};
    border-radius: 39.5px;
    border: none;
    color: ${active ? theme.v2.colors.brand.primaryExtraDark : theme.v2.colors.neutral.highPure};
    cursor: pointer;
    display: flex;
    flex-wrap: nowrap;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    gap: 8px;
    height: 48px;
    justify-content: center;
    padding: 12px 24px;
    white-space: nowrap;

    :hover {
      background: ${!active && 'rgba(255, 255, 255, 0.24)'};
    }

    svg {
      path {
        stroke: ${active ? theme.v2.colors.brand.primaryExtraDark : theme.v2.colors.neutral.highPure};
        fill: none;
      }
    }
    
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xxs};
      height: 36px;
      padding: 7px 16px;

      svg {
        height: 20px;
        width: 20px;
      }
    }
  `}
`;

export const ExpandButton = styled.button`
  ${({ theme, bannerExpanded }) => css`
    align-items: center;
    background:${theme.v2.colors.neutral.highPure};
    border-radius: 1000px;
    border: none;
    bottom: 24px;
    cursor: pointer;
    display: flex;
    height: 32px;
    justify-content: center;
    padding: 10px;
    position: absolute;
    right: 27px;
    transition: transform 0.3s;

    svg {
      transform: rotate(${bannerExpanded ? '0deg' : '180deg'});
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      top: 24px;
      right: 24px;
      bottom: auto;
    }
  `}
`;

export const UpgradeButtonWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;
    justify-content: center;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      margin-top: 32px;
    }
  `}
`;

export const CreditWrapper = styled.div`
  ${({ theme, bannerExpanded }) => css`
    align-items: center;
    display: flex;
    gap: 8px;
    position: absolute;
    right: ${bannerExpanded ? '20px' : '107px'};
    top:  ${bannerExpanded ? '24px' : '20px'};
    transition: right 0.3s ease-in-out;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      justify-content: flex-end;
      right: 20px;
      top: 24px;
      width: 100%;
    }
  `}
`;

export const AlertWrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    border-radius: 8px;
    position: absolute;
    right: 0px;
    top: 50px;
    width: 510px;
    z-index: 2;

    .text-price {
      white-space: nowrap;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      width: calc(100% - 40px);
    }
  `}
`;
